import { render, staticRenderFns } from "./AddTopic.vue?vue&type=template&id=31ba3ae4&"
import script from "./AddTopic.vue?vue&type=script&lang=js&"
export * from "./AddTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LrGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ba3ae4')) {
      api.createRecord('31ba3ae4', component.options)
    } else {
      api.reload('31ba3ae4', component.options)
    }
    module.hot.accept("./AddTopic.vue?vue&type=template&id=31ba3ae4&", function () {
      api.rerender('31ba3ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/add-topic/AddTopic.vue"
export default component.exports